// src/redux/slices/staffScheduleSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { staffSchedule } from "@/api/new-api/staff-management/staff/staff";

// Async thunk: staffShift fetch by ID
export const fetchStaffSchedule = createAsyncThunk(
  "staffSchedule/fetch",
  async (id, { rejectWithValue }) => {
    try {
      const response = await staffSchedule(id);

      if (response?.status === "success") {
        return response.data.shift_schedule || [];
      } else {
        return rejectWithValue(
          response?.message || "Failed to fetch staff schedule."
        );
      }
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong.");
    }
  }
);

const staffScheduleSlice = createSlice({
  name: "staffSchedule",
  initialState: {
    staffShift: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetStaffSchedule: (state) => {
      state.staffShift = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffSchedule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaffSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.staffShift = action.payload;
      })
      .addCase(fetchStaffSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStaffSchedule } = staffScheduleSlice.actions;

export default staffScheduleSlice.reducer;
